module.exports = __webpack_public_path__ + "img/12angry-11.31335721.jpg";